<template>
  <Paystack :amount="+nextPayment.amount" :email="customer.personal.email" @done="paymentDone($event)" v-if="nextPayment.amount">
    <v-btn :loading="paying" color="teal" outlined>
      <v-icon left>mdi-credit-card</v-icon>
      Pay {{ nextPayment.amount | currency }}
    </v-btn>
  </Paystack>
</template>

<script>
	import Paystack from "../Paystack";

	export default {
		name: "NextPaymentButton",
		components: { Paystack },
		data() {
			return {
				paying: false
			}
		},
		methods: {
			async paymentDone(response) {
				try {
					this.paying = true;
					if (response) {
						await this.$http.post(`https://sellbackend.creditclan.com/merchantclanbackend/public/index.php/api/payment`, {
							ref_no: response.reference,
							request_id: this.request.id,
							payment_type: +this.request.payment_type + 1,
							type: 3,
							schedule_ids: this.nextPayment.ids
						});
					}
					await this.$store.dispatch("request/load", this.request.id);
					this.paying = false;
				} catch (e) {
					console.log('Payment error', e)
					this.paying = false;
				}
			},
		},
		computed: {
			request() {
				return this.$store.state.request
			},
			customer() {
				return this.$store.state.customer
			},
			nextPayment() {
				return this.$store.getters["request/nextPayment"]
			},
		},
	}
</script>
